import { render, staticRenderFns } from "./definition.vue?vue&type=template&id=1b59d1b4&scoped=true"
import script from "./definition.vue?vue&type=script&lang=js"
export * from "./definition.vue?vue&type=script&lang=js"
import style0 from "./definition.vue?vue&type=style&index=0&id=1b59d1b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59d1b4",
  null
  
)

export default component.exports